// import { localeMap } from "@/i18n";
import { getSearchParam } from "@/utils";
export default function useLanguage() {
  const getLanByUrl = () => {
    let lan: any = getSearchParam("lan");
    // lan = localeMap.includes(lan) ? lan : "en";
    lan = lan || "en";
    return lan;
  };
  const lan = getLanByUrl();
  const isArLan =
    ["arabic-mils", "ar", "ur"].includes(lan) ||
    ["arabic-mils.comfortweather.com", "urdu-mils.comfortweather.com"].includes(window.location.hostname);
  return {
    lan,
    isArLan,
    getLanByUrl,
  };
}
